import { Injectable } from "@angular/core";
import { AppConfig } from "../../configs/app.config";
import { map, catchError, retry } from "rxjs/operators";
import { Observable, throwError, of } from "rxjs";
import { HttpClient, HttpResponse, HttpHeaders, HttpErrorResponse } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class RestService {
  constructor() { }
  public readonly BASE_API_URL: string = AppConfig.BASE_API_URL;
  public readonly BASE_CDP_URL: string = AppConfig.BASE_CDP_URL;
  public readonly BASE_ADSP_URL: string = AppConfig.BASE_ADSP_URL;
  public readonly BASE_BDSP_URL: string = AppConfig.BASE_BDSP_URL;
  public readonly BASE_TDSP_URL: string = AppConfig.BASE_TDSP_URL;
  public readonly BASE_AI_BOT_URL: string = AppConfig.BASE_AI_BOT_URL;
  public readonly BASE_DCO_URL: string = AppConfig.BASE_DCO_URL;
  public readonly BASE_SHARED_URL: string = AppConfig.BASE_SHARED_URL;

  get(this, url): Observable<any> {
    return this.http.get(url).pipe(
      map((response: HttpResponse<any>) => response)
      // ,catchError((err) => this.handleError(err))
    );
  }
  getFile(this, url): Observable<any> {
      return this.http.get(url, {
      responseType: 'blob' // Important: ensures we get the file as a Blob
    });
  }

  post(this, url, data): Observable<any> {
    return this.http.post(url, data).pipe(
      map((response: HttpResponse<any>) => response)
      // ,catchError((err) => this.handleError(err))
    );
  }

  put(this, url, data): Observable<any> {
    return this.http.put(url, data).pipe(
      map((response: HttpResponse<any>) => response)
      // ,catchError((err) => this.handleError(err))
    );
  }

  patch(this, url, data): Observable<any> {
    return this.http.patch(url, data).pipe(
      map((response: HttpResponse<any>) => response)
      // ,catchError((err) => this.handleError(err))
    );
  }

  delete(this, url): Observable<any> {
    return this.http.delete(url).pipe(
      map((response: HttpResponse<any>) => response)
      // ,catchError((err) => this.handleError(err))
    );
  }

  // handleError(this, error) {
  //   console.log(error);
  //   this.toastr.error(error.error.apnx_error);
  //   return throwError(error);
  // }
}
@Injectable({
  providedIn: "root",
})
export class EntityReadOnlyService extends RestService {
  list(this, params: Object = {}, advt = true): Observable<any> {
    return this.get(this.buildUrl(this.resource_url, "", params));
  }
  // params?:Object
  getById(this, id, params: Object = {}): Observable<any> {
    return this.get(this.buildUrl(this.resource_url, id, params));
  }

  buildUrl(url, id: any = "", params, isBulkEdit: boolean = false) {
    let queryString = this.convertToString(params);
    var suffix = isBulkEdit ? 'bulk-edit' : `${id}`;

    if (suffix) {
      suffix += "/";
    }

    if (queryString) {
      var tempUrl = url + suffix + "?" + queryString;
    } else {
      var tempUrl = url + suffix;
    }
    return tempUrl;
  }

  convertToString(params) {
    let qs = "";
    Object.keys(params).forEach((el) => {
      if (qs) {
        if (Array.isArray(params[el])) {
          let s = params[el].join();
          qs += `&${el}=${s}`;
        } else {
          qs += `&${el}=${params[el]}`;
        }
      } else {
        if (Array.isArray(params[el])) {
          let s = params[el].join();
          qs += `${el}=${s}`;
        } else {
          qs += `${el}=${params[el]}`;
        }
      }
    });
    return qs;
  }
}
@Injectable({
  providedIn: "root",
})
export class BaseEntityService extends EntityReadOnlyService {
  create(this, data, params: Object = {}): Observable<any> {
    return this.post(this.buildUrl(this.resource_url, "", params), data);
  }

  update(this, id, data, params: Object = {}): Observable<any> {
    return this.put(this.buildUrl(this.resource_url, id, params), data);
  }

  partialUpdate(this, id, data, params: Object = {}): Observable<any> {
    return this.patch(this.buildUrl(this.resource_url, id, params), data);
  }

  bulkPartialUpdate(this, data, params: object = {}): Observable<any> {
    return this.patch(this.buildUrl(this.resource_url, "", params, true), data);
  }

  destroy(this, id, params: Object = {}): Observable<any> {
    return this.delete(this.buildUrl(this.resource_url, id, params));
  }
}
